import React, { ReactNode } from 'react'
import './Modal.css'

export type Props = {
  children: ReactNode
}

function ModalFooter(props: Props) {
  const { children } = props

  return (
    <div className="modal-footer">
      {children}
    </div>
  )
}

export default ModalFooter
